import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Card, Navbar, Nav, Form, FormControl, Button } from "react-bootstrap";
import { FaSearch, FaUserCircle } from "react-icons/fa";
import logo from "../assets/logo.png"; 
import "../styles/home.css"; // Adjust the path if needed
import FieldForm from "../components/Field/FieldForm";
import Cookies from "js-cookie";
import landing from "../assets/landing1.jpg";
import api,{API_URL} from "../api.js";


const Dashboard = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [fields, setFields] = useState([]);
  const userRole = Cookies.get("user_role"); // Read role from cookies
  const token = Cookies.get("access_token")
  const [recentReports, setRecentReports] = useState([]);
  const [mostViewedReports, setMostViewedReports] = useState([]);
  const [randomReports, setRandomReports] = useState([]);

// Fetch recent reports
useEffect(() => {
  api.get("/report/recent/", {
    headers: { Authorization: `Bearer ${token}` },
  })
  .then(res => setRecentReports(res.data))
  .catch(err => console.error("Error loading recent reports", err));
}, []);

// Fetch most viewed reports
// useEffect(() => {
//   api.get("/report/most-viewed/", {
//     headers: { Authorization: `Bearer ${token}` },
//   })
//   .then(res => setMostViewedReports(res.data))
//   .catch(err => console.error("Error loading most viewed reports", err));
// }, []);

// Fetch random reports
useEffect(() => {
  api.get("/report/random/", {
    headers: { Authorization: `Bearer ${token}` },
  })
  .then(res => setRandomReports(res.data))
  .catch(err => console.error("Error loading random reports", err));
}, []);


  useEffect(() => {
    if (!token) {
      console.error("No token found");
      return; // Don't make the request if token is missing
    }

    api
      .get("/field/myfields/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setFields(response.data))
      .catch((err) => {
        if(err.response && err.response.status === 401){
          navigate('/login')
        }
        else{
        console.error("Error fetching fields:", err)
      }

      });
  }, [token]); // Include token in dependencies to update when it changes

  return (
    <>

<section id="about" className="hero-section text-white position-relative">
  <div className="overlay d-flex align-items-center">
    <div className="container">
      <div className="row h-100 align-items-center">
        <div className="col-md-4  col-12 text-end text-md-start">
          <h1 className="hero-title">
            ما دنیا را رصد می‌کنیم تا شما آماده تصمیم‌گیری باشید
          </h1>
          <p className="hero-subtitle">
            پژوهشکده رصد رهینو مرجع تحلیل و رصد فناوری‌های نوظهور برای تصمیم‌سازان، سیاست‌گذاران و فعالان نوآوری در کشور
          </p>
        </div>
      </div>
    </div>
  </div>
</section>



      {/* Tiles Section */}
      <div className="field-tile-container">
  {fields.map((field) => (
    <Link to={`/field/${field.id}`} key={field.id} className="field-tile">
      <img
        src={`${API_URL}${field.thumbnail}`}
        alt={field.title}
        className="tile-image"
      />
      <div className="tile-overlay">
        <h5 className="tile-title">{field.title}</h5>
        <span className="tile-arrow">→</span>
      </div>
    </Link>
  ))}
</div>

{/* <Container className="tiles" style={{ fontFamily: "'Vazirmatn', sans-serif", fontSize: "12px" }}>
        <Row className="g-4"> 
          {fields.map((field) => (
            <Col key={field.id} xs={12} sm={6} md={4} lg={2}>
              <Link to={`/field/${field.id}`} key={field.id} style={{ textDecoration: "none" }}>
              <Card className="tile-card">
                <Card.Img variant="top" src={"http://127.0.0.1:8000" + field.thumbnail} alt={field.title} />
                <Card.Body>
                  <Card.Title className="text-center">{field.title}</Card.Title>
                </Card.Body>
              </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container> */}


      
      <div className="field-container">
            {/* Show button only for admin or manager */}
            {(userRole === "admin" || userRole === "manager") && (
                <button className="field-btn" onClick={() => setShowForm(true)}>
                    ایجاد حوزه جدید
                </button>
            )}

            {showForm && <FieldForm show={showForm} handleClose={() => setShowForm(false)}/>}
      </div>     
      {/* Recent Reports */}
      <div className="content-section2">
        <div className="divider">
          <div className="divider-fade"><span>گزارشات اخیر</span></div>
        </div>
        <Row className="my-3">
          {recentReports.map((report, index) => (
            <Col key={report.id} xs={12} className="mb-4">
              <div className={`report-tile d-flex flex-column flex-md-row ${index % 2 === 0 ? "flex-md-row-reverse" : ""}`}>
                <div className="report-image-container">
                  <img 
                    src={report.picture || "/placeholder.jpg"} 
                    alt={report.title}
                    className="report-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/placeholder.jpg";
                    }}
                  />
                </div>
                {/* Text content */}
        <div className="text-content p-4 d-flex flex-column justify-content-center report-content bg-white">
          <h5 className="text-title fw-bold mb-5">{report.title}</h5>
          <p className="text-muted3">{report.summary?.slice(0, 200)}...</p>
          <p className="text_muted3"> {report.subject.field.title}</p>
          <p className="text-muted small mb-1">نویسنده: {report.author.username}</p>
          
          <Link to={`/report/${report.id}`} className="report-link-arrow mt-2">
    <span className="arrow-icon">←</span>
    <span className="arrow-text">ادامه</span>
    
  </Link>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

   { /* Most Viewed Reports*/}
{/* <div className="content-section">
<div className="divider">
    <div className="divider-fade"><span> پربازدیدترین گزارش ها</span></div>
  </div>
<Container className="my-5">
      
      <Row className="g-4">
        {mostViewedReports.slice(0, 1).map((r) => (
          <Col key={r.id} md={8}>
            <div className="bento-item bento-large">
              <img src={r.picture || "/placeholder.jpg"} alt={r.title} />
              <div className="bento-content">
                <h4>{r.title}</h4>
                <p>{r.summary?.slice(0, 100)}...</p>
                <Link to={`/report/${r.id}`}>مشاهده</Link>
              </div>
            </div>
          </Col>
        ))}

        <Col md={4}>
          <Row className="g-4">
            {mostViewedReports.slice(1, 3).map((r) => (
              <Col key={r.id} xs={12}>
                <div className="bento-item">
                  <img src={r.picture || "/placeholder.jpg"} alt={r.title} />
                  <div className="bento-content">
                    <h5>{r.title}</h5>
                    <Link to={`/report/${r.id}`}>مشاهده</Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Col>

        {mostViewedReports.slice(3, 6).map((r) => (
          <Col key={r.id} md={4}>
            <div className="bento-item">
              <img src={r.picture || "/placeholder.jpg"} alt={r.title} />
              <div className="bento-content">
                <h5>{r.title}</h5>
                <Link to={`/report/${r.id}`}>مشاهده</Link>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
    </div> */}

    <div className="content-section">
<div className="divider">
    <div className="divider-fade"><span> گزیده ای از گزارش ها</span></div>
  </div>
<Container className="my-5">
      
      <Row className="g-4">
        {randomReports.slice(0, 1).map((r) => (
          <Col key={r.id} md={8}>
            <div className="bento-item bento-large">
              <img src={r.picture || "/placeholder.jpg"} alt={r.title} />
              <div className="bento-content">
                <h4>{r.title}</h4>
                <p>{r.summary?.slice(0, 100)}...</p>
                <Link to={`/report/${r.id}`}>مشاهده</Link>
              </div>
            </div>
          </Col>
        ))}

        <Col md={4}>
          <Row className="g-4">
            {randomReports.slice(1, 3).map((r) => (
              <Col key={r.id} xs={12}>
                <div className="bento-item">
                  <img src={r.picture || "/placeholder.jpg"} alt={r.title} />
                  <div className="bento-content">
                    <h5>{r.title}</h5>
                    <Link to={`/report/${r.id}`}>مشاهده</Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Col>

        {randomReports.slice(3, 6).map((r) => (
          <Col key={r.id} md={4}>
            <div className="bento-item">
              <img src={r.picture || "/placeholder.jpg"} alt={r.title} />
              <div className="bento-content">
                <h5>{r.title}</h5>
                <Link to={`/report/${r.id}`}>مشاهده</Link>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
    </div>

    </>
  );
};

export default Dashboard;